import React from 'react';
import './ProspectCard.css';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';

export class ScoutingReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      report0: false,
      report1: false,
      report2: false
    };
    this.saveReport = this.saveReport.bind(this);
  }

  selectReport(e, report) {
    if (report === 0) {
      this.setState(prevState => ({ report0: !prevState.report0 }));
    }
    if (report === 1) {
      this.setState(prevState => ({ report1: !prevState.report1 }));
    }
    if (report === 2) {
      this.setState(prevState => ({ report2: !prevState.report2 }));
    }
    if (report === 3) {
      this.setState(prevState => ({ report3: !prevState.report3 }));
    }
    if (report === 4) {
      this.setState(prevState => ({ report4: !prevState.report4 }));
    }
    if (report === 5) {
      this.setState(prevState => ({ report5: !prevState.report5 }));
    }
  }

  saveReport() {
    let newReport = {
      report: {
        playerid: this.props.selectedPlayer.playerID,
        skating: +document.getElementById('reportSkating').value,
        sense: +document.getElementById('reportSense').value,
        puck_skills: +document.getElementById('reportPuck').value,
        compete: +document.getElementById('reportCompete').value,
        character: +document.getElementById('reportCharacter').value,
        physical_projection: +document.getElementById('reportPhysical').value,
        comments: document.getElementById('reportComments').value
      }
    };
    console.log(newReport, JSON.stringify(newReport));
    axios
      .post(apiServerUrl + '/save_scouting_report', newReport, requestOptions())
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  deleteReport() {
    axios
      .delete(apiServerUrl + '/save_scouting_report', requestOptions())
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <div
          id="reportOne"
          style={{
            display: 'flex',
            flex: 2,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'stretch'
          }}
        >
          <div style={{ justifyContent: 'center', padding: '1em' }}>
            <table
              style={{
                display: 'table',
                width: '100%',
                margin: '1em 0',
                outlineBottom: '2px solid black'
              }}
            >
              <tbody>
                <tr>
                  <th>Attributes Summary</th>
                  <th>MIN</th>
                  <th>MAX</th>
                  <th>AVG</th>
                </tr>
                <tr>
                  <td>Skating</td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.skating.min}
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.skating.max}
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.skating.avg.toFixed(
                      2
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Hockey Sense</td>
                  <td>{this.props.selectedPlayerScouting.summary.sense.min}</td>
                  <td>{this.props.selectedPlayerScouting.summary.sense.max}</td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.sense.avg.toFixed(
                      2
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Puck Skills</td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.puck_skills.min}
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.puck_skills.max}
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.puck_skills.avg.toFixed(
                      2
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Compete</td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.compete.min}
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.compete.max}
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.compete.avg.toFixed(
                      2
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Character</td>
                  <td>
                    {
                      this.props.selectedPlayerScouting.summary.character_rating
                        .min
                    }
                  </td>
                  <td>
                    {
                      this.props.selectedPlayerScouting.summary.character_rating
                        .max
                    }
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.character_rating.avg.toFixed(
                      2
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Physical Projection</td>
                  <td>
                    {
                      this.props.selectedPlayerScouting.summary
                        .physical_projection.min
                    }
                  </td>
                  <td>
                    {
                      this.props.selectedPlayerScouting.summary
                        .physical_projection.max
                    }
                  </td>
                  <td>
                    {this.props.selectedPlayerScouting.summary.physical_projection.avg.toFixed(
                      2
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ margin: '1em' }}>
            <div>
              <strong>Scouting Reports</strong>
            </div>
            {this.props.selectedPlayerScouting.all.map((key, value) => (
              <div>
                <div
                  className="reportButton"
                  onClick={e => this.selectReport(e, value)}
                >
                  <span>Scouting Report #{value + 1}</span>
                </div>
                {((value === 0 && this.state.report0) ||
                  (value === 1 && this.state.report1) ||
                  (value === 2 && this.state.report2) ||
                  (value === 3 && this.state.report3) ||
                  (value === 4 && this.state.report4) ||
                  (value === 5 && this.state.report5) ||
                  (value === 6 && this.state.report6)) && (
                  <div>
                    <div style={{ margin: '1em' }}>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <th>Skating</th>
                            <th>Puck Skills</th>
                            <th>Hockey Sense</th>
                          </tr>
                          <tr>
                            <td>{key.skating}</td>
                            <td>{key.puck_skills}</td>
                            <td>{key.sense}</td>
                          </tr>
                          <tr>
                            <th>Character</th>
                            <th>Compete</th>
                            <th>Physical Projection</th>
                          </tr>
                          <tr>
                            <td>{key.character_rating}</td>
                            <td>{key.compete}</td>
                            <td>{key.physical_projection}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style={{ margin: '1em' }}>
                      <span>Comments</span>
                    </div>
                    <div
                      style={{
                        margin: '1em',
                        padding: '0.5em',
                        border: '1px solid black'
                      }}
                    >
                      <span
                        style={{ padding: '1em', margin: '1em', width: '100%' }}
                      >
                        {key.comments}
                      </span>
                    </div>
                    <div style={{ margin: '1em' }}>
                      <span>{key.saved_date}</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div
            style={{
              margin: '1em',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              className="reportButton"
              onClick={e =>
                (document.getElementById('newReport').style.display = 'initial')
              }
            >
              <span>Write New Report</span>
            </div>
            <div id="newReport" style={{ display: 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.5"
                  placeholder="Skating"
                  className="reportInput"
                  id="reportSkating"
                />
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.5"
                  placeholder="Hockey Sense"
                  className="reportInput"
                  id="reportSense"
                />
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.5"
                  placeholder="Puck Skills"
                  className="reportInput"
                  id="reportPuck"
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.5"
                  placeholder="Character"
                  className="reportInput"
                  id="reportCharacter"
                />
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.5"
                  placeholder="Compete"
                  className="reportInput"
                  id="reportCompete"
                />
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.5"
                  placeholder="Physical Projection"
                  className="reportInput"
                  id="reportPhysical"
                />
              </div>
              <textarea
                rows="5"
                cols="60"
                placeholder="Write new scouting report"
                id="reportComments"
              />
              <input
                type="submit"
                value="Save"
                style={{ width: '20%' }}
                onClick={this.saveReport}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ScoutingReport.js